// MasterPage.js
import React from 'react';
import Header from '../components/Header';
// import Footer from '../components/Footer';
import styled from 'styled-components'

const MasterPage = ({ children }) => {
  return (
    <div>
      <Header/>
      <StyledContainer>
        <main className='mainContainer'>
          {children}  {/* This is where the child content will be rendered */}
        </main>
      </StyledContainer>
      {/* <Footer/> */}
    </div>
  );
};

export default MasterPage;

const StyledContainer = styled.div`
  .mainContainer {
    //background-color: darkslateblue;
    //background-color: #f3f3f3;
  }
}
`